/* eslint-disable consistent-return */
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { ELEMENT_QUESTION_STYLE, QuestionStyleOptions } from './QuestionStyle.types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

const QuestionStyleElement = dynamicEditorComponent(() =>
  import('./Element/QuestionStyleElement').then((mod) => mod.QuestionStyleElement)
);

export const QuestionStyleReadOnlyPlugin = (options: QuestionStyleOptions = {}): SlatePlugin => {
  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;
      if (element.type === ELEMENT_QUESTION_STYLE) {
        return <QuestionStyleElement {...renderProps} {...options} />;
      }
    },
    inlineTypes: [ELEMENT_QUESTION_STYLE],
  };
};
